import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { profileShareService } from '../../services/profileShareService';
import type { ProfileShare } from '../../types';
import { PassportProfileCard } from './PassportProfileCard';
import { PublicPassportShell } from './PublicPassportShell';

export const SharedProfileView: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [share, setShare] = useState<ProfileShare | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!token) { setNotFound(true); setLoading(false); return; }

    profileShareService.getShareByToken(token).then(({ data, error }) => {
      if (error || !data) {
        setNotFound(true);
      } else {
        setShare(data);
      }
      setLoading(false);
    });
  }, [token]);

  if (loading) {
    return <PublicPassportShell loading />;
  }

  if (notFound || !share) {
    return (
      <PublicPassportShell
        title="Link not found or expired"
        message="This shared profile link is invalid or has expired. Please ask the sender to generate a new one."
        error
      />
    );
  }

  const { selected_fields: fields, profile_snapshot: snap } = share;
  const expiryDate = new Date(share.expires_at).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <PassportProfileCard
      fields={fields}
      profile={snap.profile}
      workExperience={snap.work_experience}
      qualifications={snap.qualifications}
      references={snap.references}
      documents={snap.documents ?? []}
      bannerRight={`Shared profile · expires ${expiryDate}`}
      footerLeft={`This link expires ${expiryDate}`}
    />
  );
};
